<template>
  <b-container>
    <Heading type="h1" :title="trans('global.products')" />
    <div v-if="!dataReady" style="font-size: 30px; text-align: center; margin-top: 60px;">
      <i class="far fa-circle-notch fa-spin"></i> {{ trans('global.loading') }}...
    </div>
    <div v-else>
      <b-row style="margin-top: -33px;">
        <b-col>
          <p>{{ trans('products.all_index.showing') }} {{ numberOfProducts }} {{ trans('global.products').toLowerCase() }}</p>
        </b-col>
      </b-row>
      <b-row v-if="!products">
        <b-col>
          <div class="alert alert-warning">
            <i class="fas fa-exclamation-triangle padding-right-6"></i> {{ trans('products.no_products') }}
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <div class="vary-table">
            <div class="thead">
              <div class="row">
                <div class="col" style="flex: 0 0 200px;">
                  {{ trans('products.all_index.image') }}
                </div>
                <div class="col">
                  {{ trans('products.all_index.name') }}
                </div>
                <div class="col col-auto">
                  {{ trans('products.all_index.actions') }}
                </div>
              </div>
            </div>
            <div class="tbody">
              <div v-for="product in products" :key="product._id" class="row">
                <div class="col" style="flex: 0 0 200px;">
                  <b-img v-if="productImage(product)" :src="productImage(product)"></b-img>
                  <div v-else style="display: flex; justify-content: center; align-items: center; background-color: #a6a6a6; opacity: 0.2; width: 100px; height: 100px; border-radius: 4px; color: #392a2a;">
                    <i class="far fa-unlink" style="vertical-align: center; font-size: 40px;"></i>
                  </div>
                </div>
                <div class="col">
                  <!-- <b-link :to="'/projects/' + project.slug + '/sales/' + prospect.slug"> -->
                  <b-link
                    class="font-size-large"
                    :to="'/products/edit/' + product.varycode"
                  >
                    {{ product.name }}
                  </b-link>
                </div>
                <div class="col col-auto overflow-visible">
                  <b-dropdown size="md" variant="primary" no-caret right>
                    <template v-slot:button-content>
                      <i class="fas fa-caret-down"></i>
                    </template>
                    <b-dropdown-item @click="deleteProduct(product)">
                      {{ trans('global.delete') }}
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
  import { mapState } from 'vuex'
  import Heading from '../../components/Core/Heading'

  const fb = require('../../firebaseConfig')

  export default {
    name: 'AllProducts',
    components: {
      Heading
    },
    data () {
      return {
        loading: true
      }
    },
    computed: {
      ...mapState({
        products: state => state.products.products
      }),
      dataReady () {
        return this.products !== undefined && this.products.length > 0
      },
      numberOfProducts () {
        return this.products.length
      }
    },
    beforeMount () {
      this.updateBreadcrumb([{ text: this.trans('global.products'), to: '/products' }, { text: this.trans('navigation.all_products'), to: '#' }])
    },
    methods: {
      productImage (product) {
        const imageKey = product.image !== undefined && Object.keys(product.image).length > 0 ? Object.keys(product.image)[Object.keys(product.image).length - 1] : false

        return imageKey ? process.env.VUE_APP_IMAGE_CDN_URL + '/' + product.image[imageKey].path + '/' + product.image[imageKey].file + '?fit=crop&w=100&h=100&mask=corners&corner-radius=5,5,5,5' : false
        // return this.products
      },
      deleteProduct (productData) {
        this.$bvModal.msgBoxConfirm(this.trans('prospects.designer.delete_product_are_you_sure', { product: productData.name }), {
          title: this.trans('prospects.designer.delete_confirm'),
          size: 'sm',
          buttonSize: 'md',
          okVariant: 'danger',
          okTitle: this.trans('global.delete'),
          cancelTitle: this.trans('global.cancel')
        }).then((value) => {
          if (value !== false) {
            fb.productsCollection.doc(productData._id).update({
              deleted: true
            }).then(() => {
              this.$bvToast.toast(this.trans('prospects.designer.delete_confirmed'), {
                title: this.trans('global.success'),
                variant: 'success',
                solid: true
              })
            }).catch((err) => {
              console.log('Error while deleting product')
              console.log(err)
            })
          } else {
            console.log('Deletions was aborted')
          }
        }).catch((err) => {
          console.log('Error')
          console.log(err)
        })
      }
    }
  }
</script>
